


























































































import Vue from "vue";
import { Component,  Prop, Watch } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import { AppConstants as _app } from "@/shared/app.constants";
import { Utilities as utils } from "@/shared/utilities";
import { GrantData, IGrant } from "@/entities";
// import ReportComponent from '../../Reports/Report.vue';
import HeaderInfo from '@/components/App/Modules/GMS/Grants/ExpansionPanel/ExpansionPanel.vue';
import ReportPeriodEditor from './ReportPeriodEditor.vue';
import PermissionService from '@/services/permission.service';
import { Feedback, TechnicalReportData } from "@/entities";

const permissionService = new PermissionService();
const namespace: string = "grant";

@Component({
    components: {
        HeaderInfo,
        ReportPeriodEditor
    }
})
export default class TechnicalReports extends Vue {
    @State(namespace) technicalReport!: TechnicalReportData;
    @Getter("_appUser", { namespace: "RootApp" }) _username!: string;
    @Getter("readGrant", { namespace }) grant: IGrant;
    @Action("startTechnicalReport", { namespace: 'technicalReport'}) startTechnicalReport: any;
    @Action("updateReportPeriod", { namespace: 'technicalReport' }) updateTechnicalReport: any;
    @Prop() grantId: number;
    @Prop() reports!: any;

    search: string = '';
    headers: any = [];
    actions = _app.actions;
    subjects = _app.subjects;
    techReportStatus = _app.techReportStatus;
    editDialog: boolean = false;
    selectedReport: any = {};
    technicalReportSections: any;
    technicalReportData: any;
    editIcon = 'mdi-pencil-outline';
    title = 'Edit';
    ppoAccess:boolean = false;
    initiativeId:number = 0;

    /** mounted fn */
    mounted() {
        this.initiativeId = this.grant.InitiativeId;
        this.headers = _app.reportingPeriodHeaders;
        this.headers.map(x => {
            x.text = this.$t(x.text);
        });
    }

    /** format date */
    formatDate(dt: any) {
        return utils.formatDate(dt);
    }

    /** edit the selected item */
    editItem(item: any) {
        let reportId = item.TechnicalReportId.toString();
        // #. if not started, then start the report and navigate.
        const reportComponent: string = (item.IsFinalPeriod) ? 'finalTechnicalReport' : 'technicalReport';
        if(item.WorkFlowStatusId === this.techReportStatus.notStarted) {
            this.startTechnicalReport(item.TechnicalReportId)
            .then((resp) => {
                if (resp) {
                    this.$router.push({
                        name: reportComponent,
                        params: { technicalReportId: reportId, reportLength: this.reports.length },
                        hash: '#summary'
                    });
                }
            });
        } else {
            this.$router.push({
                name: reportComponent,
                params: { technicalReportId: reportId, reportLength: this.reports.length },
                hash: '#summary'
            });
        }        
    }

    get grantData() {
        const self = this;
        return self.technicalReport.grantData.techReport.filter(x => x.reportId === self.selectedReport.TechnicalReportId);
    }

    downloadPdf(item) {
        this.selectedReport = item;
        if(this.selectedReport.IsFinalPeriod) {
            this.$services.monitor.getGrantInformation(item.GrantId, item.TechnicalReportId)
                .then((result: any) => {
                    this.technicalReportData = result
                    this.technicalReportSections = result.template.reduce((obj: any, tmpl: any) => {
                        obj[tmpl.Key] = tmpl.Value;
                        return obj;
                    }, {});

                    let transformedData = this.transformDataFinalReport();
                    let option = {
                        "schema": this.technicalReportSections[ this.technicalReport.language || "en-US"].properties.finalTechnicalReportSections,
                        "data": transformedData,
                        "docTags" :this.technicalReport.documentTags,
                        "user": this._username,
                        "currency": this.technicalReport.selectedGrant.BudgetCurrency,
                        "id": this.technicalReport.selectedGrant.ApplicationId,
                        "type": "",
                        "excludeKeys": ["summary"]
                    };
                    this.$services.TechnicalReoprt.generate(option);
                })
        } else {
            this.$services.monitor.getGrantInformation(item.GrantId, item.TechnicalReportId)
                .then((result: any) => {
                    this.technicalReportData = result
                    this.technicalReportSections = result.template.reduce((obj: any, tmpl: any) => {
                        obj[tmpl.Key] = tmpl.Value;
                        return obj;
                    }, {});
                    
                    let transformedData = this.transformData();
                    let option = {
                        "schema": this.technicalReportSections[ this.technicalReport.language || "en-US"].properties.technicalReportSections,
                        "data": transformedData,
                        "docTags" :this.technicalReport.documentTags,
                        "user": this._username,
                        "currency": this.technicalReport.selectedGrant.BudgetCurrency,
                        "id": this.technicalReport.selectedGrant.ApplicationId,
                        "type": "",
                        "excludeKeys": ["summary","performance"]
                    };
                    this.$services.TechnicalReoprt.generate(option);
                })
        }
    }

    transformData() {
        let data = {};
        for(let key1 in this.grantData[0])
        {
            if(Array.isArray(this.grantData[0][key1])) {
                data[key1] = this.grantData[0][key1];
            } else {
                for(let key2 in this.grantData[0][key1])
                {
                    data[key2] = this.grantData[0][key1][key2];
                }
            }
        }
        data['monitoringPlan'] = this.technicalReportData.impact;
        for (let key1 in this.technicalReport.selectedGrant)
        {
            data[key1]=this.technicalReport.selectedGrant[key1];
        }
        data['reportingPeriod'] = this.selectedReport.Title;

        return data
    }

    transformDataFinalReport() {
        let data = {};
        for(let key1 in this.grantData[0])
        {
            if(Array.isArray(this.grantData[0][key1])) {
                data[key1] = this.grantData[0][key1];
            } else {
                for(let key2 in this.grantData[0][key1])
                {
                    data[key2] = this.grantData[0][key1][key2];
                }
            }
        }
        data['monitoringPlan'] = this.technicalReportData.impact;
        for (let key1 in this.technicalReport.selectedGrant)
        {
            if(key1 != 'monitoringPlan') {
                data[key1] = this.technicalReport.selectedGrant[key1];
            }
        }
        data['reportingPeriod'] = this.selectedReport.Title;

        return data
    }

    /** edit the period */
    editPeriod(item: any) {
        this.selectedReport = item;
        this.editDialog = true;
    }

    closeDialog() {
        this.selectedReport = {};
        this.editDialog = false;
    }

    updatePeriod() {
        let id = this.selectedReport.TechnicalReportId;
        this.updateTechnicalReport({ id, data: this.selectedReport })
        .then((data) => {
            this.selectedReport = {};
            this.editDialog = false;
        })
    }

    checkPermission(item: any, btn: string) {
        switch(btn) {
            case 'edit': {
                //@ts-ignore
                if(this.$can(this.actions.read, this.subjects.grantReports) && item.WorkFlowStatusId !== this.techReportStatus.notStarted)
                {
                    this.editIcon = 'mdi-file-search-outline';
                    this.title = 'View';
                    return true;
                }
                //@ts-ignore
                else if(this.$can(this.actions.read, this.subjects.grantReports) && item.WorkFlowStatusId === this.techReportStatus.notStarted)
                {   
                    return false; // admins should not start reporting (Bug #294971)
                }
                //@ts-ignore
                else if(this.$can(this.actions.update, this.subjects.grantReports))
                    return true;
            }
            break;

            case 'edit-period': {
                //@ts-ignore
                if((this.$can(this.actions.manage, this.subjects.periodEdit) || this.ppoAccess) && item.WorkFlowStatusId === this.techReportStatus.inProgress)
                    return true;
            }
            break;

            // case 'download': {
            //     //@ts-ignore
            //     if(this.$can(this.actions.update, this.subjects.grantReports) && [this.techReportStatus.pendingReview, this.techReportStatus.readyForValidation, this.techReportStatus.approved].includes(item.WorkFlowStatusId))
            //     {   
            //         return true;
            //     }
            // }
            // break;
        }
    }

    @Watch("initiativeId")
    enableButton(val: any) {
        if (val) {
            this.ppoHasPermission(val);
        } else {
            this.ppoAccess = false;
        }
    }

    ppoHasPermission(initiativeId) {
        // Get logged in user initiatives
        permissionService.ppoHasPermission(initiativeId).then((hasPermission: boolean) => {
            // get user initiaive
            this.ppoAccess = hasPermission;
        });
    }
}
